module.exports = __webpack_public_path__ + "static/scale-model-of-aurora-illinois-7f6b03f3043f47153535688685bf721f.png";